import API_CONFIG from "../config/api";

export const PLANNING_NOTIFICATION_EVENT = "elsa:planning-notification";

// Flux authentifie, sans token dans l'URL et sans contenu metier transporte.
// Le polling existant reste disponible si le flux est coupe par le reseau.
export function subscribeToPlanningNotifications({ token, companyId, onChange }) {
  const controller = new AbortController();
  let retryTimer, retryDelay = 1000;
  const connect = async () => {
    try {
      const response = await fetch(API_CONFIG.apiUrl("/hr/planning/notification-events"), {
        headers: { Authorization: `Bearer ${token}`, "X-Company-Id": String(companyId), Accept: "text/event-stream" },
        signal: controller.signal, cache: "no-store", skipGlobalLoading: true,
      });
      if ([401, 403, 404, 503].includes(response.status)) return;
      if (!response.ok || !response.headers.get("content-type")?.includes("text/event-stream") || !response.body?.getReader) throw new Error("Planning notification stream unavailable");
      retryDelay = 1000;
      const reader = response.body.getReader(), decoder = new TextDecoder();
      let pending = "";
      try {
        while (!controller.signal.aborted) {
          const { done, value } = await reader.read();
          if (done) break;
          pending += decoder.decode(value, { stream: true }).replace(/\r\n/g, "\n");
          let end;
          while ((end = pending.indexOf("\n\n")) >= 0) {
            const event = pending.slice(0, end); pending = pending.slice(end + 2);
            if (!controller.signal.aborted && /^event: (ready|planning-notification)$/m.test(event)) onChange();
          }
        }
      } finally { reader.releaseLock(); }
    } catch {
      retryDelay = Math.min(retryDelay * 2, 30000);
    }
    if (!controller.signal.aborted) retryTimer = setTimeout(connect, retryDelay);
  };
  void connect();
  return () => { controller.abort(); clearTimeout(retryTimer); };
}
